// prefer default export if available
const preferDefault = m => (m && m.default) || m

exports.components = {
  "component---src-pages-404-js": () => import("./../../../src/pages/404.js" /* webpackChunkName: "component---src-pages-404-js" */),
  "component---src-pages-credit-cards-index-tsx": () => import("./../../../src/pages/credit-cards/index.tsx" /* webpackChunkName: "component---src-pages-credit-cards-index-tsx" */),
  "component---src-pages-index-tsx": () => import("./../../../src/pages/index.tsx" /* webpackChunkName: "component---src-pages-index-tsx" */),
  "component---src-pages-loans-index-tsx": () => import("./../../../src/pages/loans/index.tsx" /* webpackChunkName: "component---src-pages-loans-index-tsx" */)
}

